import React from "react";
import {
  FaUser,
  FaGraduationCap,
  FaProjectDiagram,
  FaTools,
  FaEnvelope,
  FaCertificate,
  FaBriefcase,
} from "react-icons/fa";

const Header = () => {
  const navItems = [
    { name: "About", href: "#about", icon: <FaUser /> },
    { name: "Education", href: "#education", icon: <FaGraduationCap /> },
    { name: "Experience", href: "#experience", icon: <FaBriefcase /> },
    {
      name: "Certifications",
      href: "#certifications",
      icon: <FaCertificate />,
    },
    { name: "Skills", href: "#skills", icon: <FaTools /> },
    { name: "Projects", href: "#projects", icon: <FaProjectDiagram /> },
    { name: "Contact", href: "#contact", icon: <FaEnvelope /> },
  ];

  return (
    <header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px 50px",
        backgroundColor: "#000",
        color: "#fff",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* Left: Name */}
      <div style={{ fontSize: "1.8rem", fontWeight: "700" }}>Shreeya</div>

      {/* Right: Navigation */}
      <nav>
        <ul
          style={{
            display: "flex",
            listStyle: "none",
            gap: "30px",
            margin: 0,
            padding: 0,
            fontSize: "1rem",
          }}
        >
          {navItems.map((item, index) => (
            <li
              key={index}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                transition: "0.3s",
              }}
            >
              <a
                href={item.href}
                style={{
                  color: "#fff",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                {item.icon} {item.name}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
